/**
 * Avalara © 2018
 * file: engines/opus_ui/src/search/CustomerCard.js
 */
import './customerCard.css';
import axios from 'axios';
// import jwtDecode from 'jwt-decode';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { fetchCases } from '../actions/cases';
// import backfillIcon from '../assets/backfillCO-small.png';
// import jiraIcon from '../assets/jiraIcon.png';
// import salesforceIcon from '../assets/Salesforce.png';
import reprovisionIcon from '../assets/reprovision-small.png';
import config from '../config';
import { getBaseUrlFromConfig } from '../utils/url_helpers';
import { getDeliverySystemLink } from './DeliverySystemCard';
import ObligationIPS from './ObligationIPS.tsx';
// import { findUsageRatingInformationForObligationSummaries } from './UsageTable';
import { sendNotification } from '../utils/notification';
// import { getJwt } from '../utils/store';
import { UsageRerunSection } from './UsageRerunSection';
// import DataUsageIcon from '@material-ui/icons/DataUsage';
// import UsageSearchIcon from '../assets/usageSearchIcon.png';
// import ShopIcon from '@material-ui/icons/Shop';
// import Tooltip from '@material-ui/core/Tooltip';
import ErrorsAccordian from './ErrorsAccordian.jsx';
import EmergencyReprovision from './EmergencyReprovision';
import { makeGetRequest } from '../helpers/biztechAxiosRequest';
import { Loader } from '@avalara/skylab-react';
import {
  getContactsEndpoint,
  getProvisioningContactsEndpoint,
  getIPSObligationsEndpoint,
  SPECIAL_SERVICES,
  DEFAULT_IAM_DETAILS
} from '../constants/ApiEndpoints';
import CustomerAccountLogTable from '../centralizedLogger/CustomerAccountLogTable';
import { DD_MMM_YYYY_HH_MM_SS_A_Z } from '../constants/DateTimeFormats';
import { Icon } from '@avalara/skylab-react';

const salesforceBaseURL = getBaseUrlFromConfig(config.salesforce);
const zuoraBaseURL = getBaseUrlFromConfig(config.zuora);

const notAvailableResultItem = (
  <s-row>
    <s-col>Not available</s-col>
  </s-row>
);

// const backfillCOURL = `${getBaseUrlFromConfig(
//   config.biztechApi
// )}/event-notifications-publisher/events`;
// const zuoraExtractUrl = `${getBaseUrlFromConfig(
//   config.biztechApi
// )}/business-activity/zuora/customers/`;
// const customerLintApi = `${getBaseUrlFromConfig(
//   config.biztechApi
// )}/customer/customer-accounts/`;

const CARD_NAME = 'Customer Account';

const getLink = data => `/search?query=${data.id}`;

class CustomerCard extends Component {
  componentDidMount() {
    this.props.dispatch(fetchCases(this.props.data.id));
    this.checkAuthorizationToShowButtons();
    this.getIPSObligation();
    this.getSpecialServices();
    this.getIamDetails();
  }

  constructor() {
    super();
    this.state = {
      isLoading: false,
      showUsageRerunSection: false,
      customerLintData: null,
      // showBackFilling: false,
      showEventsProvision: false,
      provisioningContacts: null,
      allContacts: null,
      showingData: 'obligationIPS',
      showingContact: 'all',
      ipsObligations: [],
      ipsError: null,
      ipsLoading: false,
      isUncachedIPSObligations: false,
      specialServices: {},
      iamProductionDetails: {},
      iamSandboxDetails: {},
      showReprovisionDialog: false
    };
    this.usageSectionRef = React.createRef();
  }

  toggleReprovisionDialog = () => {
    this.setState({ showReprovisionDialog: !this.state.showReprovisionDialog });
  };

  loadingStateChanger = status => {
    this.setState({ isLoading: status });
  };

  getAvataxAccount = deliverySystemAccounts => {
    const avataxObj = deliverySystemAccounts.find(
      x => x.deliverySystem === 'avatax'
    );
    return avataxObj;
  };

  getIPSObligation = (getUncachedVersion = false, forceRefresh = false) => {
    this.setState({ ipsLoading: true });
    if (this.state.isUncachedIPSObligations && !forceRefresh) {
      this.setState({ ipsLoading: false });
      return;
    }
    const avatax = this.getAvataxAccount(
      this.props.data.deliverySystemAccountSummaries
    );

    if (!avatax) {
      const ipsError = `Avatax account does not exist, can't fetch obligations without it !!`;
      this.setState({
        ipsObligations: [],
        ipsError: ipsError,
        ipsLoading: false
      });
      return sendNotification(ipsError);
    }
    let ipsObligationsEndpoint = getIPSObligationsEndpoint(avatax.id);
    if (getUncachedVersion) {
      this.setState({ isUncachedIPSObligations: true });
      ipsObligationsEndpoint += '&$getuncached=true';
    } else {
      this.setState({ isUncachedIPSObligations: false });
    }
    makeGetRequest(ipsObligationsEndpoint)
      .then(result => {
        if (result?.data?.data?.obligations)
          this.setState({
            ipsObligations: result?.data?.data?.obligations,
            ipsLoading: false
          });
        else this.setState({ ipsObligations: [], ipsLoading: false });
      })
      .catch(error => {
        this.setState({
          ipsObligations: [],
          ipsLoading: false,
          ipsError: 'Problem Loading Obligations from IPS'
        });
        return sendNotification('Problem Loading Obligations from IPS');
      });
  };

  getSpecialServices = () => {
    makeGetRequest(SPECIAL_SERVICES)
      .then(result => {
        if (result?.data)
          this.setState({
            specialServices: result?.data
          });
      })
      .catch(error => {
        this.setState({
          specialServices: {}
        });
        return sendNotification('Problem Loading Special Services');
      });
  };

  getIamDetails = () => {
    makeGetRequest(
      DEFAULT_IAM_DETAILS +
        `?customerAccountId=${this.props.data.id}&subtype=organization`
    )
      .then(result => {
        if (result?.data)
          this.setState({
            iamProductionDetails: result?.data
          });
      })
      .catch(error => {
        this.setState({
          iamProductionDetails: {}
        });
        return sendNotification('Problem Loading IAM Data');
      });

    makeGetRequest(
      DEFAULT_IAM_DETAILS +
        `?customerAccountId=${this.props.data.id}&subtype=organizationSandbox`
    )
      .then(result => {
        if (result?.data)
          this.setState({
            iamSandboxDetails: result?.data
          });
        console.log('iamSandboxDetails', this.state.iamSandboxDetails);
      })
      .catch(error => {
        this.setState({
          iamSandboxDetails: {}
        });
        return sendNotification('Problem Loading IAM Data');
      });
  };

  getIAMDetailsUrl(id, subtype) {
    return `/${subtype}/${id || 'Not Available'}`;
  }

  getProvisionContact = () => {
    const provisioningContactsEndpoint = getProvisioningContactsEndpoint(
      this.props.data.id
    );
    makeGetRequest(provisioningContactsEndpoint)
      .then(result => {
        if (result?.data?.data)
          this.setState({ provisioningContacts: result?.data?.data });
        else this.setState({ provisioningContacts: [] });
      })
      .catch(error => {
        this.setState({ provisioningContacts: [] });
        return sendNotification("Can't Load Provision Contacts");
      });
  };

  getAllContact = () => {
    const contactsEndpoint = getContactsEndpoint(this.props.data.id);
    makeGetRequest(contactsEndpoint)
      .then(result => {
        if (result?.data?.data)
          this.setState({ allContacts: result?.data?.data });
        else this.setState({ allContacts: [] });
      })
      .catch(error => {
        this.setState({ allContacts: [] });
        return sendNotification("Can't Load Contacts");
      });
  };

  onShowingDataChange = event => {
    if (event.target.value === 'contact') {
      if (!this.state.allContacts) {
        this.getAllContact();
        this.getProvisionContact();
      }
    } else if (event.target.value === 'obligationIPS') {
      if (!this.state.ipsObligations) {
        this.getIPSObligation();
      }
    }
    this.setState({
      showingData: event.target.value
    });
  };

  onShowingContactChange = event => {
    this.setState({
      showingContact: event.target.value
    });
  };

  checkAuthorizationToShowButtons() {
    this.setState({ isLoading: true });
    this.checkAuthForEventsProvision()
      .then(result => {
        this.setState({
          showEventsProvision: result,
          isLoading: false
        });
      })
      .catch(err => {
        // console.error('error while checking for auth', err.message);
        this.setState({ isLoading: false });
      });
  }

  // checkAuthForBackfilling() {
  //   return axios
  //     .get(
  //       `${getBaseUrlFromConfig(
  //         config.biztechApi
  //       )}/default/isAuthorized/back-filling`
  //     )
  //     .then(res => {
  //       if (res.data && res.data.isAuthorized) {
  //         return true;
  //       } else {
  //         return false;
  //       }
  //     })
  //     .catch(ex => {
  //       // console.error(`unable to api request:`, ex.message);
  //       return false;
  //     });
  //   // const roles = jwtDecode(auth.token).roles;
  //   // if (!roles) return false;
  //   // const { authorizedRoles } = config;
  //   // return authorizedRoles.backfilling.some((role) => roles.indexOf(role) >= 0);
  // }


  checkAuthForEventsProvision = () => {
    return axios
      .get(
        `${getBaseUrlFromConfig(
          config.biztechApi
        )}/default/isAuthorized/events-provision`
      )
      .then(res => {
        if (res.data && res.data.isAuthorized) {
          return true;
        } else {
          return false;
        }
      })
      .catch(ex => {
        return false;
      });
  };


  // createJiraTicket(crmid, name, auth) {
  //   // we ues the window.location.href becouse they are diffrent in fqa and prod. Also if we change it we won't have to change the code here.
  //   // console.log(window.location.href);
  //   // console.log(encodeURIComponent(window.location.href));
  //   window.open(
  //     `https://avalara.atlassian.net/secure/CreateIssueDetails!init.jspa?pid=30102&issuetype=21407&customfield_30061=${crmid}
  //     &description=Error+For+${encodeURI(name.replace(' ', '+'))}
  //     &reporter=${auth.username}&summary=Error+For+${encodeURI(
  //       name.replace(' ', '+')
  //     )}
  //     &priority=5&assignee=opus.robot&labels=submittedfromgui`
  //   );
  // }

  //TODO This function violates the MVC pattern that React aims for and should be moved somewhere else
  // backfillCO(id) {
  //   this.setState({ isLoading: true });
  //   axios
  //     .post(
  //       backfillCOURL,
  //       {
  //         topic: 'customer',
  //         event: 'customer_account_obligation_backfill',
  //         context: {
  //           customerAccountId: id
  //         }
  //       },
  //       {
  //         headers: {
  //           'content-type': 'application/json'
  //         }
  //       }
  //     )
  //     .then(res => {
  //       this.setState({
  //         isLoading: false
  //       });
  //       return sendNotification('Backfill customer obligations successfull!');
  //     })
  //     .catch(error => {
  //       this.setState({
  //         isLoading: false
  //       });
  //       return sendNotification('Failed to backfill customer obligations.');
  //     });
  // }


  //TODO This function violates the MVC pattern that React aims for and should be moved somewhere else
  // zuoraExtract(id) {
  //   this.setState({ isLoading: true });
  //   axios
  //     .post(
  //       `${zuoraExtractUrl}${id}`,
  //       {},
  //       {
  //         headers: {
  //           'content-type': 'application/json'
  //         }
  //       }
  //     )
  //     .then(res => {
  //       sendNotification(`Zuora Extract queued`);

  //       this.setState({
  //         isLoading: false
  //       });
  //     })
  //     .catch(error => {
  //       sendNotification(`Zuora Extract failed`);

  //       this.setState({
  //         isLoading: false
  //       });
  //     });
  // }

  // checkUsageRerun(customerAccountId) {
  //   this.setState({
  //     isLoading: true
  //   });
  //   this.getLintDataForCustomer(customerAccountId);
  // }

  // getLintDataForCustomer(customerAccountId) {
  //   axios
  //     .get(`${customerLintApi}${customerAccountId}/lint`, {
  //       headers: {
  //         'content-type': 'application/json'
  //       }
  //     })
  //     .then(res => {
  //       this.setState({
  //         isLoading: false
  //       });
  //       this.setState({
  //         showUsageRerunSection: true,
  //         customerLintData: res.data
  //       });
  //     })
  //     .catch(err => {
  //       sendNotification('Internal Server Error');
  //       this.setState({
  //         showUsageRerunSection: false,
  //         isLoading: false
  //       });
  //     });
  // }

  componentDidUpdate() {
    if (this.state.showUsageRerunSection) this.focusDiv();
  }

  focusDiv() {
    this.usageSectionRef.current.focus();
  }

  getAccountStatus = (isActive, isSuspended) => {
    if (isSuspended) {
      if (isActive) {
        return (
          <span className="CustomerAccountStatus">
            Active (Suspended) – File AR Case in Salesforce to
          </span>
        );
      } else {
        return (
          <span className="CustomerAccountStatus"> Not Active (Suspended)</span>
        );
      }
    }
    return isActive ? 'Active' : 'Not Active';
  };

  contactRenderer = contacts => {
    return contacts && contacts.length > 0 ? (
      <table className="detailTable padding-all-xs">
        <thead>
          <tr>
            <td className="header">Name</td>
            <td className="header">Email</td>
            <td className="header">CustomerAccountId</td>
            <td className="header">Online Authorized</td>
            <td className="header">Billing Contact</td>
            <td className="header">Primary Contact</td>
            <td className="header">Interest In</td>
          </tr>
        </thead>
        {contacts.map((contact, contactIndex) => {
          return (
            <tbody key={contactIndex}>
              <tr>
                <td>{`${contact.firstName} ${contact.lastName}`}</td>
                <td>{`${contact.email}`}</td>
                <td>{`${contact.customerAccountId}`}</td>
                <td>{contact.onlineAuthorized ? 'Yes' : 'No'}</td>
                <td>{contact.isBillingContact ? 'Yes' : 'No'}</td>
                <td>{contact.isPrimaryContact ? 'Yes' : 'No'}</td>
                <td>
                  {contact.interestInProductsServices
                    ? contact.interestInProductsServices
                    : ''}
                </td>
              </tr>
            </tbody>
          );
        })}
      </table>
    ) : null;
  };

  render() {
    const { data, dispatch } = this.props;

    const { isLoading, customerLintData, ipsObligations } = this.state;

    if (isLoading) {
      document.body.style.cursor = 'wait';
    } else {
      document.body.style.cursor = 'pointer';
    }


    //get connector details from IPS obligations
    const ipsConnectorsArray = Array.isArray(ipsObligations)
      ? ipsObligations
          .map(obligation => {
            return {
              connectorName: obligation.connectorName,
              connectorId: obligation.connectorId
            };
          })
          .filter(connector => connector.connectorId || connector.connectorName)
          .sort((a, b) => (a.connectorName > b.connectorName ? 1 : -1))
      : [];

    // let usageInfo = findUsageRatingInformationForObligationSummaries(
    //   data.usageGraphQLData,
    //   data.obligationSummaries
    // );

    return (
      <s-container class="Card">
        <div className="SectionTitle">
          <div>
            {CARD_NAME}
            <h1>{data.name}</h1>
          </div>
          <div className="logo-container">

            {/* <Tooltip title="Sell Offer" placement="bottom">
              <span id="SellOfferLink">
                <Link
                  to={{
                    pathname: '/sell-offers',
                    search: `?id=${data.id}`
                  }}
                >
                  <ShopIcon style={{ color: '#059BD2', fontSize: 38 }} />
                </Link>
              </span>
            </Tooltip> */}

            {/* {this.state.showBackFilling ? (
              <span>
                <img
                  src={backfillIcon}
                  alt="BackfillCO Logo"
                  title="Backfill Customer Obligation"
                  onClick={this.backfillCO.bind(this, data.id)}
                  id="backfillLogo"
                />
              </span>
            ) : null} */}
            {/* <span>
              <img
                src={jiraIcon}
                alt="create jira ticket"
                title="create jira ticket"
                onClick={this.createJiraTicket.bind(
                  this,
                  data.id,
                  data.name,
                  this.props.auth
                )}
                id="createJiraTicket"
              />
            </span> */}
            {/* <span>
              <Link to={`/usage-search?query=${data.id}`} id="viewUsageData">
                <img
                  src={UsageSearchIcon}
                  alt="View Usage Data"
                  title="View Usage Data"
                  id="viewUsageData"
                />
              </Link>
            </span> */}
            {this.state.showReprovisioning ? (
              <span>
                <img
                  src={reprovisionIcon}
                  alt="Reprovision Logo"
                  title="Reprovision"
                  onClick={this.reprovision.bind(this, data.id)}
                  id="reprovisionLogo"
                  style={{ display: 'none' }}
                />
              </span>
            ) : null}
            {/* {this.state.showReprovisioning ? (
              <span
                style={isLoading ? { cursor: 'wait' } : { cursor: 'pointer' }}
              >
                <img
                  src={zuoraIcon}
                  alt="Zuora Icon"
                  title="Perform Zuora Extract"
                  onClick={this.zuoraExtract.bind(this, data.id)}
                  id="zuoraExtractLogo"
                  style={{ display: 'none' }}
                />
              </span>
            ) : null} */}
            {/* <a
              href={`${salesforceBaseURL}/${data.id}`}
              target="_blank"
              rel="noopener noreferrer"
              title="Salesforce"
              style={{ position: 'initial' }}
            >
              <img
                src={salesforceIcon}
                alt="Salesforce Logo"
                className="SalesforceLogo"
              />
            </a> */}
          </div>
        </div>

        <s-container>
          <s-box className="padding-all-xs" class="DetailBox">
            <s-row collapse="lg">
              <s-col span="5" class="divider-right">
                <s-row>
                  <s-col span="6">
                    <b>Customer Account Id</b>
                  </s-col>
                  <s-col span="6">{data.id ? data.id : 'Not available'}</s-col>
                </s-row>
                <s-row>
                  <s-col span="6">
                    <b>Customer Account Status</b>
                  </s-col>
                  <s-col span="6">
                    {this.getAccountStatus(
                      data.isActive,
                      data.accountState === 'Suspended'
                    )}
                  </s-col>
                </s-row>
                <s-row>
                  <s-col span="6">
                    <b>Customer Lifecycle State</b>
                  </s-col>
                  <s-col span="6">{data.accountState}</s-col>
                </s-row>
                <s-row>
                  <s-col span="6">
                    <b>Account Creation Date</b>
                  </s-col>
                  <s-col span="6">
                    {data.createdAt
                      ? new Date(data.createdAt).toLocaleDateString()
                      : 'Not available'}
                  </s-col>
                </s-row>
                <s-row>
                  <s-col span="6">
                    <b>Support Level</b>
                  </s-col>
                  <s-col span="6">
                    {data.createdAt ? data.supportLevel : 'Not available'}
                  </s-col>
                </s-row>
                <s-row>
                  <s-col span="6">
                    <b>Customer Account Manager</b>
                  </s-col>
                  <s-col span="6">
                    {data.camName ? data.camName : 'Not available'}
                  </s-col>
                </s-row>
                <s-row>
                  <s-col span="6">
                    <b>Primary Contact</b>
                  </s-col>
                  <s-col span="6">
                    {data.primaryContactName && data.primaryContactEmail
                      ? `${data.primaryContactName} (${data.primaryContactEmail})`
                      : 'Not available'}
                  </s-col>
                </s-row>
                <s-row>
                  <s-col span="6">
                    <b>Autopay</b>
                  </s-col>
                  <s-col span="6">{data.zuoraAutopay ? `Yes` : 'No'}</s-col>
                </s-row>
                <hr />
                <div className="connectors-div-parent">
                  <div
                    className="connector-div-child"
                    id="iamProductionDetails"
                  >
                    <b>Organization:</b>
                    <div
                      key={
                        this.state.iamProductionDetails?.organization
                          ?.displayName || 'Not Available'
                      }
                    >
                      {' '}
                      {this.state.iamProductionDetails?.organization
                        ?.displayName || 'Not Available'}
                    </div>
                    {this.state.iamProductionDetails?.organization?.id && (
                      <Link
                        key="organizationLink"
                        className="Link"
                        to={this.getIAMDetailsUrl(
                          this.state.iamProductionDetails?.organization?.id ||
                            'Not Available',
                          'organization'
                        )}
                      >
                        {this.state.iamProductionDetails?.organization?.id ||
                          'Not Available'}
                      </Link>
                    )}
                  </div>
                  <div className="connector-div-child" id="iamSandboxDetails">
                    <b>Organization Sandbox:</b>
                    <div
                      key={
                        this.state.iamSandboxDetails?.organization
                          ?.displayName || 'Not Available'
                      }
                    >
                      {' '}
                      {this.state.iamSandboxDetails?.organization
                        ?.displayName || 'Not Available'}
                    </div>
                    {this.state.iamSandboxDetails?.organization?.id && (
                      <Link
                        key="organizationSandboxLink"
                        className="Link"
                        to={this.getIAMDetailsUrl(
                          this.state.iamSandboxDetails?.organization?.id ||
                            'Not Available',
                          'organizationSandbox'
                        )}
                      >
                        {this.state.iamSandboxDetails?.organization?.id ||
                          'Not Available'}
                      </Link>
                    )}
                  </div>
                </div>
              </s-col>
              <s-col span="7">
                <div className="margin-bottom-sm">
                  <b>Delivery System Accounts</b>
                  <br />
                </div>
                <div>
                  {data.deliverySystemAccountSummaries ? (
                    <>
                      <table className="detailTable">
                        <thead>
                          <tr>
                            <td className="header">Delivery System</td>
                            <td className="header">ID</td>
                            <td className="header">Created At</td>
                            <td className="header">Modified At</td>
                          </tr>
                        </thead>
                        {data.deliverySystemAccountSummaries.map(
                          (accountSummary, accountIndex) => {
                            return (
                              <tbody key={accountIndex}>
                                <tr>
                                  <td>{accountSummary.deliverySystem}</td>
                                  <td>
                                    <Link
                                      key={`${accountSummary.deliverySystem}-${accountSummary.id}`}
                                      className="Link"
                                      to={getDeliverySystemLink(accountSummary)}
                                    >
                                      {accountSummary.id}
                                    </Link>
                                  </td>
                                  <td>
                                    {moment(accountSummary.createdAt).format(
                                      DD_MMM_YYYY_HH_MM_SS_A_Z
                                    )}
                                  </td>
                                  <td>
                                    {moment(accountSummary.modifiedAt).format(
                                      DD_MMM_YYYY_HH_MM_SS_A_Z
                                    )}
                                  </td>
                                </tr>
                              </tbody>
                            );
                          }
                        )}
                      </table>
                    </>
                  ) : (
                    notAvailableResultItem
                  )}
                </div>
                <hr />
                <div className="connectors-div-parent">
                  <div className="connector-div-child" id="IPS-connectors">
                    <b>Connectors (IPS Obligations) :</b>
                    {ipsConnectorsArray.map((connector, index) => {
                      return (
                        <div
                          key={`${connector.connectorName}-${connector.connectorId}-${index}`}
                        >
                          {connector.connectorName} - {connector.connectorId}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </s-col>
            </s-row>
          </s-box>
          {/* Commenting this section from to hide billing information
          <s-box className="padding-all-xs" class="DetailBox">
            <s-row collapse="lg">
              <div className="margin-left-sm">
                <b>Billing Information</b>
              </div>
              <br />
              <table className="detailTable">
                {data.billingAccountSummaries &&
                data.billingAccountSummaries.length > 0 ? (
                  <thead>
                    <tr>
                      <td className="header">ACCOUNT NUMBER</td>
                      <td className="header">AUTOPAY</td>
                      <td className="header">BILLING CONTACT</td>
                    </tr>
                  </thead>
                ) : null}
                {data.billingAccountSummaries &&
                data.billingAccountSummaries.length > 0
                  ? data.billingAccountSummaries.map(
                      (billingAccountSummary, billingAccountSummaryIndex) => {
                        return (
                          <tbody key={billingAccountSummaryIndex}>
                            <tr>
                              <td>{billingAccountSummary.accountNumber}</td>
                              <td>
                                {billingAccountSummary.autoPay ? 'Yes' : 'No'}
                              </td>
                              <td>
                                {`${billingAccountSummary.billingContact.FirstName} ${billingAccountSummary.billingContact.LastName}
                        (${billingAccountSummary.billingContact.WorkEmail})`}
                              </td>
                            </tr>
                          </tbody>
                        );
                      }
                    )
                  : notAvailableResultItem}
              </table>{' '}
            </s-row>
          </s-box> */}
          <br />
          <div>
            {this.state.ipsLoading && (
              <button className="disabledButton icon-trailing" disabled>
                Fetching IPS Obligations... <Icon name="refresh" />
              </button>
            )}
            {!this.state.ipsLoading && (
              <button
                className="activeButton icon-trailing"
                onClick={() => {
                  this.getIPSObligation(true, true);
                }}
              >
                Refresh IPS Obligations <Icon name="refresh" />
              </button>
            )}
          </div>
          <br />
          {this.state.ipsLoading && (
            <div className="margin-all-sm">
              <s-row>
                <Loader loading={true} />
              </s-row>
              <s-row>
                <s-col span="3"></s-col>
                <s-col span="8">
                  <p class="margin-all-auto">
                    Fetching Obligations from the IPS for determining
                    provisioning failures
                  </p>
                </s-col>
              </s-row>
            </div>
          )}
          {!this.state.ipsLoading && (
            <ErrorsAccordian
              ipsObligations={ipsObligations ? ipsObligations : []}
              deliverySystemDataSubscriptions={
                data.deliverySystemDataSubscriptions
              }
              crmId={data.id}
              defaultExpanded={this.state.isUncachedIPSObligations}
              showEventsProvision={this.state.showEventsProvision}
              loadingStateChanger={this.loadingStateChanger}
              getUncachedObligation={this.getIPSObligation}
              specialServices={this.state.specialServices}
            />
          )}
          <EmergencyReprovision
            showDialog={this.state.showReprovisionDialog}
            toggleDialog={this.toggleReprovisionDialog}
            crmId={data.id}
            loadingStateChanger={this.loadingStateChanger}
          />
          <br />
          {this.state.showUsageRerunSection ? (
            <UsageRerunSection
              divRef={this.usageSectionRef}
              deliverySystem={
                data.deliverySystemAccountSummaries
                  ? data.deliverySystemAccountSummaries
                  : []
              }
              customerAccountId={data.id}
              customerLintData={customerLintData}
              obligationSummaries={data.obligationSummaries}
            />
          ) : null}
          <s-box className="padding-all-xs" class="DetailBox">
            <div className="tabWrapper">
              <input
                className="radio"
                id="obligationIPS"
                value="obligationIPS"
                name="group"
                type="radio"
                checked={this.state.showingData === 'obligationIPS'}
                onChange={this.onShowingDataChange}
              />
              <input
                className="radio"
                id="contact"
                value="contact"
                name="group"
                type="radio"
                checked={this.state.showingData === 'contact'}
                onChange={this.onShowingDataChange}
              />
              <input
                className="radio"
                id="centralizedLog"
                value="centralizedLog"
                name="group"
                type="radio"
                checked={this.state.showingData === 'centralizedLog'}
                onChange={this.onShowingDataChange}
              />
              <div className="tabs">
                <label
                  className="tab"
                  id="obligationIPS-tab"
                  htmlFor="obligationIPS"
                >
                  Obligations
                </label>
                <label className="tab" id="contact-tab" htmlFor="contact">
                  Contact
                </label>
                <label
                  className="tab"
                  id="centralizedLog-tab"
                  htmlFor="centralizedLog"
                >
                  Recent Activities
                </label>
              </div>
            </div>
            {this.state.showingData === 'obligationIPS' &&
              this.state.ipsLoading && (
                <div className="margin-all-sm">
                  <s-row>
                    <Loader loading={true} />
                  </s-row>
                  <s-row>
                    <s-col span="4"></s-col>
                    <s-col span="6">
                      <p class="margin-all-auto">
                        Getting Obligations from IPS, Please Wait
                      </p>
                    </s-col>
                  </s-row>
                </div>
              )}
            {this.state.showingData === 'obligationIPS' &&
              !this.state.ipsLoading &&
              this.state.ipsError && (
                <div className="margin-all-sm">
                  <s-row>
                    <s-col span="4"></s-col>
                    <s-col span="6">
                      <p class="margin-all-auto">
                        <h3>{this.state.ipsError}</h3>
                      </p>
                    </s-col>
                  </s-row>
                </div>
              )}
            {this.state.showingData === 'obligationIPS' &&
              !this.state.ipsLoading &&
              !this.state.ipsError && (
                <ObligationIPS
                  obligationSummaries={this.state.ipsObligations}
                  getUncachedObligation={this.getIPSObligation}
                />
              )}
            {this.state.showingData === 'contact' && (
              <s-row collapse="lg" class="margin-left-xs">
                <s-col>
                  <input
                    id="allContact"
                    value="all"
                    name="contactGroup"
                    type="radio"
                    checked={this.state.showingContact === 'all'}
                    onChange={this.onShowingContactChange}
                    className="radio margin-all-sm padding-all-xs"
                  />
                  <label htmlFor="allContact">All Contacts</label>
                  <input
                    id="provisioningContact"
                    value="provisioning"
                    name="contactGroup"
                    type="radio"
                    checked={this.state.showingContact === 'provisioning'}
                    onChange={this.onShowingContactChange}
                    className="radio margin-all-sm padding-all-xs"
                  />
                  <label htmlFor="provisioningContact">
                    Provisioning Contacts
                  </label>
                </s-col>
                {this.state.showingContact === 'all' &&
                  (this.state.allContacts &&
                  this.state.allContacts.length > 0 ? (
                    this.contactRenderer(this.state.allContacts)
                  ) : (
                    <table>
                      <s-row>
                        {!this.state.allContacts && <Loader loading={true} />}
                      </s-row>
                      <s-row>
                        <s-col span="4"></s-col>
                        <s-col span="6">
                          <p class="margin-all-auto">
                            {!this.state.allContacts &&
                              'Getting Contacts for you please wait'}
                            {this.state.allContacts && 'No Contacts Available'}
                          </p>
                        </s-col>
                      </s-row>
                    </table>
                  ))}
                {this.state.showingContact === 'provisioning' &&
                  (this.state.provisioningContacts &&
                  this.state.provisioningContacts.length > 0 ? (
                    this.contactRenderer(this.state.provisioningContacts)
                  ) : (
                    <table>
                      <s-row>
                        {!this.state.provisioningContacts && (
                          <Loader loading={true} />
                        )}
                      </s-row>
                      <s-row>
                        <s-col span="4"></s-col>
                        <s-col span="6">
                          <p class="margin-all-auto">
                            {!this.state.provisioningContacts &&
                              'Getting Provisioning Contacts for you please wait'}
                            {this.state.provisioningContacts &&
                              'No Provisioning Contact Available'}
                          </p>
                        </s-col>
                      </s-row>
                    </table>
                  ))}
              </s-row>
            )}
            {this.state.showingData === 'centralizedLog' && (
              <CustomerAccountLogTable
                customerAccountId={data.id}
                showEventsProvision={this.state.showEventsProvision}
                onEmergencyReprovisioningClick={this.toggleReprovisionDialog}
              />
            )}
          </s-box>
          <br />
          <s-row class="title">
            <s-col span="3">
              <b>Recent Transactions</b>
            </s-col>
          </s-row>
          {data.transactionSummaries
            ? data.transactionSummaries.map(transactionSummary => {
                return (
                  <s-row key={transactionSummary.id}>
                    <s-col span="3">
                      {new Date(
                        transactionSummary.effectiveFrom
                      ).toLocaleDateString()}
                    </s-col>
                    <s-col span="7">
                      {`${transactionSummary.type} `}
                      <a
                        className="Link"
                        target="_blank"
                        rel="noopener noreferrer"
                        href={
                          transactionSummary.externalId.length === 32
                            ? `${zuoraBaseURL}/apps/Amendment.do?method=viewInfo&id=${transactionSummary.externalId}`
                            : `${salesforceBaseURL}/${transactionSummary.externalId.substring(
                                0,
                                18
                              )}`
                        }
                      >
                        {`(ref: ${transactionSummary.externalId})`}
                      </a>
                    </s-col>
                  </s-row>
                );
              })
            : notAvailableResultItem}
        </s-container>
      </s-container>
    );
  }
}

export { getLink };
export default CustomerCard;
